import * as user from "./modules/user/data";
import * as client from "./modules/client/data";
import * as plans from "./modules/prices/data";

export const constant = { user, client, plans };
